import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvlOverSpeed } from '@features/live-tracking/models/avl-over-speed.model';

@Component({
  selector: 'app-avl-over-speed-marker',
  template: `
    <app-marker [size]="size" style="transform: translate(-50%, -50%)"
                (click)="togglePopup.emit(positionId)">
      <mat-icon class="text-error">network_check</mat-icon>
    </app-marker>


    <div class="card--shifted" *ngIf="activePopupId === positionId">
      <mat-card class="p-3" style="padding: 0.75rem !important;">
        <app-row>
          <app-col class="ml-auto" cols="auto">
            <button
              mat-icon-button
              type="button"
              style="margin: -.75rem -.75rem 0 0;"
              (click)="togglePopup.emit(null)"><mat-icon>close</mat-icon></button>
          </app-col>
        </app-row>

        <app-row style="margin-top: -1rem;">
          <app-col>
            <div class="pb-2"><b>Speed</b>: {{position.speed}} KM/hr</div>
          </app-col>
        </app-row>
      </mat-card>
    </div>
  `,
  styles: [
    `
      .card--shifted {
        transform: translate(-50%, -125%);
        padding-bottom: 1rem;
        font-size: 1rem;
        min-width: 240px;
      }
    `
  ]
})
export class AvlOverSpeedMarkerComponent {
  @Input() size: 'xs'|'sm'|'md'|'lg';
  @Input() activePopupId: string;
  @Input() position: AvlOverSpeed;
  @Output() togglePopup = new EventEmitter();

  positionId = (Math.random() * 1000).toString(32) + Date.now().toString(32);

  markerSize: 'xs'|'sm'|'md'|'lg' = 'md';

}
